import React, { useEffect, useRef, useState } from 'react'
import SocialNetworks from './SocialNetworks'
import './Footer.scss'

const Footer = () => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false)
  const tooltipRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
        setShowTooltip(false)
      }
    }
    showTooltip ? document.addEventListener('mousedown', handleClickOutside) : document.removeEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showTooltip])

  return (
    <>
      <footer className="footer">
        <div className="container">
          <h3>Subscribe to newsletter</h3>
          <div className="subscribe">
            <input type="email" placeholder="Enter your mail" aria-label="Email" />
            <button className="button">Subscribe</button>
          </div>
          <p>
            By Subscribing I Accept The{' '}
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          </p>

          <div className="footer-social">
            <h4>Follow Us</h4>
            <SocialNetworks />
          </div>

          <div className="footer-address">
            Lynk Management Ltd t/a TECHTONIC SOFTWARE CONTRACTORS
            Reg no: 15892372<br />
            <i className="fa-solid fa-location-dot"></i>
            Spring Court, Spring Road, Hale, Altrincham, England WA14 2UQ
          </div>

          <div className="footer-bottom">
            <div className="footer-terms">
              <div id="tooltip-holder">
                <a
                  href="#terms"
                  onClick={(e) => {
                    e.preventDefault()
                    setShowTooltip((prev) => !prev)
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Terms and Conditions
                </a>

                <div
                  ref={tooltipRef}
                  className={`tooltip ${showTooltip ? 'visible' : ''}`}
                >
                  Our Terms and Conditions of Business form our Master Services Agreement, which is available on request.
                </div>
                &nbsp;| &nbsp;
                <a href="/privacy-policy">Privacy Policy</a>
              </div>
            </div>
            <p>&copy; {new Date().getFullYear()} All rights reserved.</p>
          </div>
        </div>

      </footer>
    </>
  )
}

export default Footer
